import { Pipe, PipeTransform } from '@angular/core';
import { LoginService } from '../../../../../../services/login/login.service';

@Pipe({
  name: 'precio'
})
export class PrecioPipe implements PipeTransform {
  constructor(private login?: LoginService){}
  transform(precio: any, args?: any): any {
    if (this.login.isLogged()) {
      const dataUser = this.login.getDataClientePedido();
      if (dataUser.es_publicogeneral === 'SI'){
        return Number(precio) * 1.16;
      }
      return precio;
    }
    return Number(precio) * 1.16;
  }
}
